import NextProjectButton from 'components/project/NextProjectButton';
import ProjectIntro from 'components/project/ProjectIntro';
import { IProjectList } from 'components/project/ProjectList';
import CloseProject from 'components/shared/CloseProject';

// import weatherApp from '../assets/website/weatherApp/index.html'
import '../assets/scss/weather-app.scss'

// const web = require('../assets/website/weatherApp/weatherApp.html');


import React, { Component } from 'react';
import variables from "../assets/scss/variables.module.scss";
import { Button, Col, Container, Row } from 'react-bootstrap';


const projectLists: Array<IProjectList> = [{
    nameOfList: 'Category',
    items: ["Front-end"]
},
{
    nameOfList: 'Technology',
    items: ["React", "Redux", "Typescript", "Gulp", "Bootstrap"]
}];

const summary: string = "A weather forecast app built with React";

class weatherApp extends Component {

    componentDidMount() {
        document.body.style.backgroundColor = variables.colorProjectBg;
    }

    render() {
        return (
            <div>
                <CloseProject />
                <ProjectIntro summary={summary} projectLists={projectLists} title={"Weather App"} />
                <Container  >
                    <Row>
                        <Col className="d-flex justify-content-center m-bottom">
                            <a href="http://www.ollieonline.nl/weatherApp" rel="noreferrer" target="_blank">
                                <Button variant="danger" size="lg">Open in new tab</Button>
                            </a>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <a href="https://github.com/l-ollie/open-weather-web-app" target="_blank" rel="noreferrer">
                                <Button variant="outline-danger" size="lg">Github</Button>
                            </a>
                        </Col>
                    </Row>
                </Container>


                <NextProjectButton />
            </div>
        );
    }
}

export default weatherApp;
